"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeLineEventDecorator = void 0;
const date_fns_1 = require("date-fns");
const lodash_1 = require("lodash");
class TimeLineEventDecorator {
    /**
     * プレーンなイベントをタイムラインの表示用のイベントに変換して返す
     * NOTE:
     * ここにeventsを100個とか渡すと100*100回の計算が走る
     * パフォーマンス的に問題になるようなら、日毎に分けるなどの対応が必要
     * @param events
     * @returns
     */
    static decorate(events) {
        const placedEvents = [];
        events.forEach((event) => {
            const indent = this.findIndent(event, placedEvents);
            placedEvents.push({ event, indent });
        });
        return placedEvents;
    }
    /**
     * 配置できるインデントを見つける
     * 1. イベントと時間が被っている配置済みのイベントを抽出
     * 2. 0から順番に空いているインデントを探す
     * @param event
     * @param placedEvents
     * @returns
     */
    static findIndent(event, placedEvents) {
        let finded = false;
        let indent = 0;
        // 1. イベントと時間が被っている配置済みのイベントを抽出
        const overlappedEvents = placedEvents.filter((pev) => (0, date_fns_1.areIntervalsOverlapping)(event.period, pev.event.period));
        // 2. 0から順番に空いているインデントを探す
        while (!finded) {
            const eventAtIndent = overlappedEvents.find((oev) => oev.indent === indent);
            (0, lodash_1.isUndefined)(eventAtIndent) ? (finded = true) : (indent += 1);
        }
        return indent;
    }
}
exports.TimeLineEventDecorator = TimeLineEventDecorator;
//# sourceMappingURL=timeLineEventDecorator.js.map